import { useCallback } from 'react';

import { useRouterPaths } from '~/redux/slices/location/hooks';
import { useAppHistory } from '~/utilities/routing';

/**
 * @description Using the returned callback will push to the history stack a path to the view
 * that is rendered on a layer below the menu router.
 *
 * @return Callback for closing a popup without triggering scrolling in the main route
 */
export function useClosePopup(): () => void {
  const history = useAppHistory();
  const { popup, main, menu } = useRouterPaths();

  return useCallback(() => {
    history.push(menu ? popup ?? main : main, { preventScrollToTop: true });
  }, [history, popup, main, menu]);
}
